import * as actions from 'redux/actions/domainsData.actions'

const updateKeyword = (keyword, newKeywordData, type) => {
  switch (type) {
    case actions.loadKeywordsSuccess.type: {
      return {
        ...keyword,
        ...newKeywordData,
        attributes: {
          ...keyword.attributes,
          ...newKeywordData.attributes
        }
      }
    }
    case actions.loadKeywordsResultsSuccess.type: {
      return {
        ...keyword,
        ...newKeywordData,
        attributes: {
          ...keyword.attributes,
          ...newKeywordData.attributes,
          competition: newKeywordData.attributes.competition || 0,
          constPerClick: newKeywordData.attributes.constPerClick || 0,
          keywordDifficulty: newKeywordData.attributes.keywordDifficulty || 0,
          searchVolume: newKeywordData.attributes.searchVolume || 0,
          traffic: newKeywordData.attributes.traffic || 0,
          result: {
            data: {
              attributes: {
                ...newKeywordData.attributes
              }
            }
          }
        }
      }
    }
    case actions.loadKeywordsChangesSuccess.type: {
      return {
        ...keyword,
        ...newKeywordData,
        attributes: {
          ...keyword.attributes,
          ...newKeywordData.attributes,
          result: {
            ...(keyword.attributes?.result || {})
          }
        }
      }
    }
    default:
      return keyword
  }
}

export default updateKeyword
